import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  Typography,
} from "@mui/material";

const PartRequestModal = ({
  partRequestModalOpen,
  handleClosePartRequestModal,
  partDescription,
  setPartDescription,
  handlePartRequestSubmit,
  isLoading = false,
}) => {
  return (
    <Dialog
      open={partRequestModalOpen}
      onClose={handleClosePartRequestModal}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        <Typography variant="h6" component="div">
          Part Request
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Box sx={{ mt: 2 }}>
          <TextField
            label="Part Description"
            multiline
            rows={4}
            fullWidth
            variant="outlined"
            value={partDescription}
            onChange={(e) => setPartDescription(e.target.value)}
            placeholder="Describe the parts needed for this service request..."
            helperText="Please provide detailed description of the parts required"
          />
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClosePartRequestModal} disabled={isLoading}>
          Cancel
        </Button>
        <Button
          onClick={handlePartRequestSubmit}
          variant="contained"
          color="primary"
          disabled={!partDescription.trim() || isLoading}
        >
          {isLoading ? "Submitting..." : "Submit Request"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PartRequestModal;
